<template>
	<div class="container">
		<b-row>
			<b-container>
				<h3 class="text-center py-2" v-if="!generado">
					<b><i>{{ f_titulo() }}</i></b>
				</h3>

				<h5 class="text-center py-2">
					<b-row class="mb-4 justify-content-center align-items-end text-lg">
						<b-col md="auto" class="text-center px-3">
							<label class="d-block fw-bold fs-4 mb-3"><b>Cod. Reporte:</b></label>
							<select v-model="dialogReportes" @click="isEmpty = true"
								class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
								<option value="">Seleccione...</option>
								<option v-for="reporte in reportes" :key="reporte.id" :value="reporte.codigo">
									{{ reporte.nombre }}
								</option>
							</select>
						</b-col>

						<b-col md="auto" class="text-center px-3">
							<label class="d-block fw-bold fs-4 mb-3"><b>Vigencia:</b></label>
							<select v-model="dialogFechas" @click="isEmpty = true"
								class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
								<option value="">Seleccione...</option>
								<option v-for="fecha in fechas" :key="fecha.fecha" :value="fecha.fecha">
									{{ fecha.fecha }}
								</option>
							</select>
						</b-col>

						<b-col md="auto" class="text-center px-3">
							<label class="d-block fw-bold fs-4 mb-3"><b>Grupo:</b></label>
							<select v-model="grupoId" @change="filtraCompaniasPorGrupo()"
								class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
								<option value="todos">Todos los grupos</option>
								<option v-for="grupo in listGrupos" :key="'grupo-' + grupo.id" :value="grupo.id">
									{{ grupo.nombre }}
								</option>
							</select>
						</b-col>

						<b-col md="auto" class="text-center px-3">
							<label class="d-block fw-bold fs-4 mb-3"><b>Compañía:</b></label>
							<select v-model="dialogCompanias" @click="seleccionaCompania()"
								class="form-control form-control-lg w-auto mx-auto fs-5"
								style="min-width: 180px; max-width: 250px;">
								<option value="">Seleccione...</option>
								<option v-for="compania in companiasFiltradas" :key="compania.id" :value="compania.id">
									{{ compania.acronym ? compania.acronym + ' ' : '' }}{{ compania.nombre }}
								</option>
							</select>
						</b-col>
					</b-row>

					<b-row class="mb-4 justify-content-center align-items-center">
<!-------
						<b-col md="auto" class="text-center px-3">
							<input type="checkbox" id="comparativo" value="Comparativo" @click="uncheck(1)"
								class="mr-1">
							<label for="comparativo" class="fw-bold">{{ labels.comparativo }}</label>
						</b-col>

						<b-col md="auto" class="text-center px-3">
							<input type="checkbox" id="directo" value="Directo" @click="uncheck(2)" class="mr-1">
							<label for="directo" class="fw-bold">{{ labels.directo }}</label>
						</b-col>
------->

						<b-col md="auto" class="text-center px-3">
							<input type="checkbox" id="indirecto" value="Indirecto" @click="uncheck(3)" class="mr-1" readonly>
							<label for="indirecto" class="fw-bold">{{ labels.indirecto }}</label>
						</b-col>

						<b-col md="auto" class="text-center px-3">
							<input type="checkbox" id="informacion" value="Informacion" @click="uncheck_nivel(0)"
								class="mr-1">
							<label for="informacion" class="fw-bold">{{ labels.informaciond }}</label>
						</b-col>

						<b-col md="auto" class="text-center px-3">
							<input type="checkbox" id="infAjusteConsol" value="InfAjusteConsol" @click="uncheck_nivel(5)"
								class="mr-1">
							<label for="inf_consolidado" class="fw-bold">{{ labels.infAjusteConsol }}</label>
						</b-col>
						<b-col md="auto" class="text-center px-3">
							<input type="checkbox" id="infAjusteComb" value="InfAjusteComb" @click="uncheck_nivel(6)"
								class="mr-1">
							<label for="inf_consolidado" class="fw-bold">{{ labels.infAjusteComb }}</label>
						</b-col>

						<b-col md="auto" class="text-center px-3">
							<input type="checkbox" id="consolidado" value="Consolidado" @click="uncheck(4)"
								class="mr-1">
							<label for="consolidado" class="fw-bold">{{ labels.consolidado }}</label>
						</b-col>
					</b-row>

					<b-row class="mb-4 justify-content-center align-items-center">
						<b-col md="auto" class="text-center px-3">
							<input type="checkbox" id="nivel_1" value="nivel_1" @click="uncheck_nivel(1)" class="mr-1">
							<label for="nivel_1" class="fw-bold">Nivel 1</label>
						</b-col>

						<b-col md="auto" class="text-center px-3">
							<input type="checkbox" id="nivel_2" value="nivel_2" @click="uncheck_nivel(2)" class="mr-1">
							<label for="nivel_2" class="fw-bold">Nivel 2</label>
						</b-col>

						<b-col md="auto" class="text-center px-3">
							<input type="checkbox" id="nivel_3" value="nivel_3" @click="uncheck_nivel(3)" class="mr-1">
							<label for="nivel_3" class="fw-bold">Nivel 3</label>
						</b-col>

						<b-col md="auto" class="text-center px-3">
							<input type="checkbox" id="nivel_4" value="nivel_4" @click="uncheck_nivel(4)" class="mr-1">
							<label for="nivel_4" class="fw-bold">Nivel 4</label>
						</b-col>

						<b-col md="auto" class="text-center px-3" v-if="consolidado">
							<input type="checkbox" id="Empresas" value="Empresas" @click="uncheck(41)" class="mr-1">
							<label for="Empresas" class="fw-bold">Empresas</label>
						</b-col>
					</b-row>

					<b-row class="mb-4 justify-content-center align-items-center">
						<b-col md="auto" class="text-center">
							<b-button variant="primary" @click="generar" class="btn-lg px-5 mx-2 fs-5">
								<b><i>{{ labels.generar }}</i></b>
							</b-button>
						</b-col>
					</b-row>

					<b-row v-if="empresas && consolidado" class="mt-4">
						<b-col md="12">
							<div class="consolidation-section p-4 border rounded bg-light">
								<label class="d-block fw-bold fs-5 mb-3 text-center">
									<b>Empresas para consolidar:</b>
								</label>

								<div class="mb-3 text-center">
									<b-form-checkbox v-model="selectAllCompanies" @change="toggleAllCompanies"
										class="fw-bold fs-6">
										{{ selectAllCompanies ? 'Deseleccionar todas' : 'Seleccionar todas' }}
									</b-form-checkbox>
								</div>

								<div class="companies-checkbox-list"
									style="max-height: 300px; overflow-y: auto; border: 1px solid #ccc; padding: 15px; border-radius: 5px; background-color: white;">
									<b-form-checkbox-group v-model="EmpresasConsolida" stacked class="checkbox-group">
										<b-form-checkbox v-for="compania in companiasFiltradas" :key="compania.id"
											:value="compania.id" class="company-checkbox">
											{{ compania.acronym }} {{ compania.nombre }}
										</b-form-checkbox>
									</b-form-checkbox-group>
								</div>

								<div class="text-center mt-3">
									<b-button variant="outline-secondary" @click="empresas = false" class="btn-sm">
										Ocultar selección
									</b-button>
								</div>
							</div>
						</b-col>
					</b-row>
				</h5>
			</b-container>
		</b-row>

		<b-row v-if="isLoading">
            <b-container v-if="isLoading" class="pb-5" style="min-height: 400px;">
                <div class="text-center py-5">
                    <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                    <h4 class="text-primary mt-3">
                        <b><i>Cargando información...</i></b>
                    </h4>
                </div>
            </b-container>
		</b-row>

		<b-row>
			<b-container v-if="!isLoading && !isEmpty && comparativo" class="pb-5">
				<md-table v-model="balanceFiltrado" md-card md-fixed-header
					:class="{ 'balance-table': true, 'principal-table': true }">
					<md-table-toolbar>
						<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
							<div style="flex: 1; text-align: center;">
								<h1 class="md-title"><b><i>{{ f_titulo() }}</i></b></h1>
							</div>
							<div style="display: flex; align-items: center; gap: 10px;">
								<md-button v-if="fgl_excel" @click="excel(1)" class="md-fab md-primary"
									style="margin-left: 10px;">
									<md-icon>description</md-icon>
								</md-button>
							</div>
						</div>
					</md-table-toolbar>
					<md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!ocultarRegistro(item)">
						<md-table-cell :md-label="labels.descripcion" class="text-left border descripcion-cell">{{
							item.descripcion }}</md-table-cell>
						<md-table-cell :md-label="labels.saldo_anterior" class="text-right border number-cell"
							v-if="f_escribe_renglon(item.informacion)">{{ formato(item.anterior) }}</md-table-cell>
						<md-table-cell :md-label="labels.saldo_anterior" v-if="!f_escribe_renglon(item.informacion)"
							class="text-right border"></md-table-cell>
						<md-table-cell :md-label="labels.saldo_actual" class="text-right border number-cell"
							v-if="f_escribe_renglon(item.informacion)">{{ formato(item.actual) }}</md-table-cell>
						<md-table-cell :md-label="labels.saldo_actual" v-if="!f_escribe_renglon(item.informacion)"
							class="text-right border"></md-table-cell>
						<md-table-cell :md-label="labels.diferencia" class="text-right border number-cell"
							v-if="f_escribe_renglon(item.informacion)">{{ formato(item.diferencia) }}</md-table-cell>
						<md-table-cell :md-label="labels.diferencia" v-if="!f_escribe_renglon(item.informacion)"
							class="text-right border"></md-table-cell>
					</md-table-row>
				</md-table>
			</b-container>

			<b-container
				v-if="!isLoading && !isEmpty && (directo || indirecto) && !informacion && !consolidado && !infAjusteConsol && !infAjusteComb"
				class="pb-5">
				<md-table v-model="balanceFiltrado" md-card md-fixed-header
					:class="{ 'balance-table': true, 'principal-table': true }">
					<md-table-toolbar>
						<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
							<div style="flex: 1; text-align: center;">
								<h1 class="md-title"><b><i>{{ f_titulo() }}</i></b></h1>
							</div>
							<div style="display: flex; align-items: center; gap: 10px;">
								<md-button v-if="fgl_excel" @click="excel(2)" class="md-fab md-primary"
									style="margin-left: 10px;">
									<md-icon>description</md-icon>
								</md-button>
							</div>
						</div>
					</md-table-toolbar>
					<md-table-row slot="md-table-row" slot-scope="{ item }">
						<md-table-cell :md-label="labels.descripcion" class="text-left border descripcion-cell">
							{{ formatearDescripcion(item.descripcion) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.monto" class="text-right border number-cell"
							v-if="f_escribe_renglon(item.tipo)">{{ formato(item.valor) }}</md-table-cell>
						<md-table-cell :md-label="labels.monto" class="text-right border"
							v-if="!f_escribe_renglon(item.tipo)"></md-table-cell>
					</md-table-row>
				</md-table>
			</b-container>
			<b-container v-if="!isLoading && !isEmpty && (directo || indirecto) && !informacion && consolidado"
				class="pb-5">
				<md-table v-model="balanceFiltrado" md-card md-fixed-header
					:class="{ 'balance-table': true, 'principal-table': true }">
					<md-table-toolbar>
						<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
							<div style="flex: 1; text-align: center;">
								<h1 class="md-title"><b><i>{{ f_titulo() }}</i></b></h1>
							</div>
							<!-- Switch -->
							<div class="compact-toggle-container">
								<div class="toggle-label">
									{{ vistaConsolidado === 'Normal' ? 'Normal' : 'Combinado' }}
								</div>

								<label class="compact-switch">
									<input type="checkbox" v-model="vistaConsolidadoBool">
									<span class="compact-slider"></span>
								</label>
							</div>
							<div style="display: flex; align-items: center; gap: 10px;">
								<md-button v-if="fgl_excel" @click="excel(4)" class="md-fab md-primary"
									style="margin-left: 10px;">
									<md-icon>description</md-icon>
								</md-button>
							</div>
						</div>
					</md-table-toolbar>

					<md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!ocultarRegistro(item)">
						<md-table-cell :md-label="labels.descripcion" class="text-left border descripcion-cell">
							{{ item.descripcion }}
						</md-table-cell>

						<md-table-cell v-for="index in columnas" :key="'col-' + index"
							:md-label="titulo_columna[index - 1] || `Empresa ${index}`" class="text-right border"
							:class="{ 'number-cell': f_escribe_renglon(item.informacion) }">
							<template v-if="f_escribe_renglon(item.informacion)">
								{{ formato(item['c' + index]) }}
							</template>
						</md-table-cell>

						<md-table-cell :md-label="labels.ajustes" class="text-right border"
							:class="{ 'number-cell': f_escribe_renglon(item.informacion) }">
							<template v-if="f_escribe_renglon(item.informacion) && columnas > 0">
								{{ formato(item.ajustes) }}
							</template>
						</md-table-cell>

						<md-table-cell :md-label="labels.consolidado" class="text-right border"
							:class="{ 'number-cell': f_escribe_renglon(item.informacion) }">
							<template v-if="f_escribe_renglon(item.informacion) && columnas > 0">
								{{ formato(item.total) }}
							</template>
						</md-table-cell>

						<md-table-cell :md-label="labels.ajustesCombinado" class="text-right border"
							:class="{ 'number-cell': f_escribe_renglon(item.informacion) }" v-if="vistaConsolidado == 'Combinado'">
							<template v-if="f_escribe_renglon(item.informacion) && columnas > 0 ">
								{{ formato(item.combinado) }}
							</template>
						</md-table-cell>

						<md-table-cell :md-label="labels.combinado" class="text-right border"
							:class="{ 'number-cell': f_escribe_renglon(item.informacion) }" v-if="vistaConsolidado == 'Combinado'">
							<template v-if="f_escribe_renglon(item.informacion) && columnas > 0">
								{{ formato(item.total_combinado) }}
							</template>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</b-container>

			<b-container v-if="!isLoading && !isEmpty && informacion" class="pb-5">
				<md-table v-model="balanceFiltrado" md-card md-fixed-header @md-selected="f_muestra"
					:class="{ 'balance-table': true, 'detalle-table': true }">
					<md-table-toolbar>
						<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
							<div style="flex: 1; text-align: center;">
								<h1 class="md-title"><b><i>{{ f_titulo() }}</i></b></h1>
							</div>
							<div style="display: flex; align-items: center; gap: 10px;">
								<md-button v-if="fgl_excel" @click="excel(3)" class="md-fab md-primary"
									style="margin-left: 10px;">
									<md-icon>description</md-icon>
								</md-button>
							</div>
						</div>
					</md-table-toolbar>
					<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single"
						v-if="!ocultarRegistro(item)">
						<md-table-cell :md-label="labels.nivel1" class="text-left border descripcion-cell">{{
							item.nivel_1_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.nivel2" class="text-left border descripcion-cell">{{
							item.nivel_2_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.nivel3" class="text-left border descripcion-cell">{{
							item.nivel_3_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.nivel4" class="text-left border descripcion-cell">{{
							item.nivel_4_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.monto" class="text-right border number-cell">{{
							formato(item.valor) }}</md-table-cell>
						<md-table-cell :md-label="labels.funcional" class="text-right border number-cell">{{
							formato(item.funcional1) }}</md-table-cell>
					</md-table-row>
				</md-table>
			</b-container>

			<b-container v-if="!isLoading && !isEmpty && infAjusteConsol" class="pb-5">
				<md-table v-model="balance" md-card md-fixed-header @md-selected="f_muestraConsolidado"
					:class="{ 'balance-table': true, 'detalle-table': true }">
					<md-table-toolbar>
						<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
							<div style="flex: 1; text-align: center;">
								<h1 class="md-title"><b><i>{{ f_titulo() }}</i></b></h1>
							</div>
							<div style="display: flex; align-items: center; gap: 10px;">
								<md-button v-if="fgl_excel" @click="excel(5)" class="md-fab md-primary"
									style="margin-left: 10px;">
									<md-icon>description</md-icon>
								</md-button>
							</div>
						</div>
					</md-table-toolbar>
					<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single"
						v-if="!ocultarRegistro(item)">
						<md-table-cell :md-label="labels.nivel1" class="text-left border descripcion-cell">{{
							item.nivel_1_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.nivel2" class="text-left border descripcion-cell">{{
							item.nivel_2_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.nivel3" class="text-left border descripcion-cell">{{
							item.nivel_3_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.nivel4" class="text-left border descripcion-cell">{{
							item.nivel_4_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.monto" class="text-right border number-cell">{{
							formato(item.valor) }}</md-table-cell>
						<md-table-cell :md-label="labels.funcional" class="text-right border number-cell">{{
							formato(item.funcional1) }}</md-table-cell>
					</md-table-row>
				</md-table>
			</b-container>
			<b-container v-if="!isLoading && !isEmpty && infAjusteComb" class="pb-5">
				<md-table v-model="balance" md-card md-fixed-header @md-selected="f_muestraCombinado"
					:class="{ 'balance-table': true, 'detalle-table': true }">
					<md-table-toolbar>
						<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
							<div style="flex: 1; text-align: center;">
								<h1 class="md-title"><b><i>{{ f_titulo() }}</i></b></h1>
							</div>
							<div style="display: flex; align-items: center; gap: 10px;">
								<md-button v-if="fgl_excel" @click="excel(6)" class="md-fab md-primary"
									style="margin-left: 10px;">
									<md-icon>description</md-icon>
								</md-button>
							</div>
						</div>
					</md-table-toolbar>
					<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single"
						v-if="!ocultarRegistro(item)">
						<md-table-cell :md-label="labels.nivel1" class="text-left border descripcion-cell">{{
							item.nivel_1_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.nivel2" class="text-left border descripcion-cell">{{
							item.nivel_2_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.nivel3" class="text-left border descripcion-cell">{{
							item.nivel_3_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.nivel4" class="text-left border descripcion-cell">{{
							item.nivel_4_desc }}</md-table-cell>
						<md-table-cell :md-label="labels.monto" class="text-right border number-cell">{{
							formato(item.valor) }}</md-table-cell>
						<md-table-cell :md-label="labels.funcional" class="text-right border number-cell">{{
							formato(item.funcional1) }}</md-table-cell>
					</md-table-row>
				</md-table>
			</b-container>

			<b-container v-if="!isLoading && isEmpty">
				<b-col md="2" class="mx-auto">
					<div class="success-svg mb-4" :class="{ active: isEmpty }">
						<img src="../../assets/imgs/file-2.svg" alt="warning" />
					</div>
				</b-col>
				<b-col md="12" class="justify-content-around">
					<span id="message" v-if="isEmpty">{{ labels.empty }}</span>
				</b-col>
			</b-container>
		</b-row>

		<md-dialog :md-active.sync="showDialogInformacion">
			<md-dialog-title class="text-center">
				<h3><b><i>{{ f_titulo_informacion() }}</i></b></h3>
			</md-dialog-title>
			<md-dialog-content>
				<b-form-group @submit.prevent="editaInfoBalance">
					<b-row><b-col cols=2>
							<h6>{{ labels.nivel1 }}</h6>
						</b-col>
						<b-col cols=10> <md-field> <md-input v-model="formInformacion.nivel_1_desc" type="text" size="100"
									readonly></md-input></md-field></b-col></b-row>
					<b-row><b-col cols=2>
							<h6>{{ labels.nivel2 }}</h6>
						</b-col>
						<b-col cols=10> <md-field> <md-input v-model="formInformacion.nivel_2_desc" type="text"
									readonly></md-input></md-field></b-col></b-row>
					<b-row><b-col cols=2>
							<h6>{{ labels.nivel3 }}</h6>
						</b-col>
						<b-col cols=10> <md-field> <md-input v-model="formInformacion.nivel_3_desc" type="text"
									readonly></md-input></md-field></b-col></b-row>
					<b-row><b-col cols=2>
							<h6>{{ labels.nivel4 }}</h6>
						</b-col>
						<b-col cols=10> <md-field> <md-input v-model="formInformacion.nivel_4_desc" type="text"
									readonly></md-input></md-field></b-col></b-row>
					<b-row><b-col cols=2>
							<h6>{{ labels.monto }}</h6>
						</b-col>
						<b-col cols=10> <md-field> <md-input v-model="formInformacion.valor"
									type="text"></md-input></md-field></b-col></b-row>
					<b-row><b-col cols=2>
							<h6>{{ labels.funcional }}</h6>
						</b-col>
						<b-col cols=10> <md-field> <md-input v-model="formInformacion.funcional1"
									type="text"></md-input></md-field></b-col></b-row>
				</b-form-group>
				<md-dialog-actions>
					<md-button class="md-primary" @click="f_grabaInformacion()" :disabled="isVigenciaBloqueada">Guardar</md-button>
					<md-button class="md-accent" @click="showDialogInformacion = false">Cerrar</md-button>
				</md-dialog-actions>
			</md-dialog-content>
		</md-dialog>
	</div>
</template>

<script>
import Balance from "@/services/BalanceNiif"
import Grupo from "@/services/Grupo"
import * as XLSX from "exceljs"

export default {
	name: "BalanceNiif",

	data: () => ({
		rolSeleccionado: {},
		myOptions: [],
		vistaConsolidado: 'Normal',
		rolSelected: '',
		showDialog: false,
		showDialogInformacion: false,
		dialogItem: {},
		balance: [],
		dialogReportes: '',
		codReporte: 0,
		reportes: [],
		searched: [],
		isEmpty: true,
		isLoading: false,
		fgl_excel: true,
		error: false,
		formInformacion: {
			nivel_1: '',
			nivel_1_desc: '',
			nivel_2: '',
			nivel_2_desc: '',
			nivel_3: '',
			nivel_3_desc: '',
			nivel_4: '',
			nivel_4_desc: '',
			valor: '',
			funcional1: '',
			u_modifica: '',
			directo: '',
		},
		idCompania: 0,
		moneda: "",
		vigencia: '',
		informacion: false,
		infAjusteConsol: false,
		infAjusteComb: false,
		comparativo: false,
		directo: false,
		indirecto: true,
		consolidado: false,
		empresas: false,
		companias: [],
		companiasFiltradas: [],
		companiaUsuario: [],
		dialogCompanias: '',
		EmpresasConsolida: [],
		fechas: [],
		dialogFechas: '',
		columnas: 0,
		titulo_columna: [],
		empresa: 0,
		generado: false,
		codigoCompanias: "",
		nivel: 1,
		descripcion: "",
		listGrupos: [],
		grupoId: '',
		selectAllCompanies: false,
	}),
	computed: {
		vistaConsolidadoBool: {
			get() {
				return this.vistaConsolidado === 'Combinado';
			},
			set(value) {
				this.vistaConsolidado = value ? 'Combinado' : 'Normal';
			}
		},
		balanceFiltrado() {
			if (!this.balance || this.balance.length === 0) return [];
			return this.balance.filter((item, index) => !this.ocultarRegistro(item, index, this.balance));
		},

		labels() {
			if (this.$store.state._language == "es-ES") {
				return {
					title: "BALANCE",
					codigo: "Codigo",
					descripcion: "Descripcion",
					saldo_anterior: "Saldo Periodo Anterior",
					saldo_actual: "Saldo Periodo Actual",
					diferencia: "Diferencia",
					monto: "Valor",
					funcional: "Funcional",
					empty: "Sin Informacion",
					notFoundMessage: "Sin Informacion",
					generar: "Generar",
					ajustes: "Ajustes",
					ajustesCombinado: "Ajustes Combinado",
					consolidado: "Consolidado",
					combinado: "Combinado",
					moneda: "Moneda",
					nivel1: "Nivel 1",
					nivel2: "Nivel 2",
					nivel3: "Nivel 3",
					nivel4: "Nivel 4",
					informacion: "Informacion Manual",
					comparativo: "Comparativo",
					directo: "Directo",
					indirecto: "Indirecto",
					informaciond: "Valor Manual",
					nivel: "Nivel",
					infAjusteConsol: "Ajuste Consolidado",
					infAjusteComb: "Ajuste Combinado",
				}
			} else {
				return {
					title: "NIIF CHECKING BALANCE",
					codigo: "Code",
					descripcion: "Description",
					saldo_anterior: "Previous Period Balance",
					saldo_actual: "Current Period Balance",
					diferencia: "Difference",
					monto: "Amount",
					funcional: "Funtional",
					compania: "Company",
					empty: "Without Information",
					notFoundMessage: "Without Information",
					generar: "Generate",
					ajustes: "Settings",
					ajustesCombinado: "Combinated Settings",
					consolidado: "Consolidated",
					combinado: "Combinated",
					moneda: "Currency",
					nivel1: "Level 1",
					nivel2: "Level 2",
					nivel3: "level 3",
					nivel4: "level 4",
					informacion: "manual information",
					comparativo: "comparative",
					directo: "direct",
					indirecto: "indirect",
					informaciond: "Manual Information",
					infAjusteConsol: "Consolidated Adjustment",
					infAjusteComb: "Combination Adjustment",
					nivel: "Level",
				}
			}
		}
	},
	methods: {
		filtraCompaniasPorGrupo() {
			this.isEmpty = true
			this.dialogCompanias = null

			if (this.grupoId === 'todos' || !this.grupoId) {
				this.companiasFiltradas = [...this.companias]
			} else {

				const grupoIdStr = this.grupoId.toString()
				this.companiasFiltradas = this.companias.filter(compania => {
					if (!compania.id_grupos) return false
					const gruposCompania = compania.id_grupos.split(',').map(id => id.trim())
					return gruposCompania.includes(grupoIdStr)
				})
			}
		},

		toggleAllCompanies() {
			if (this.selectAllCompanies) {
				this.EmpresasConsolida = this.companiasFiltradas.map(c => c.id)
			} else {
				this.EmpresasConsolida = []
			}
		},

		ocultarRegistro(item, index, array) {

			if (!item) return false;

			if (item.tipo === "I" && item.valor !== null && parseFloat(item.valor) === 0) {
				return true;
			}

			if (item.tipo === "T" && item.valor !== null && parseFloat(item.valor) === 0) {
				return true;
			}

			if (item.tipo === "E" && index > 0) {
				for (let i = index - 1; i >= 0; i--) {
					const anterior = array[i];
					if (!anterior) continue;
					if (anterior.tipo === "E" &&
						anterior.descripcion === item.descripcion &&
						anterior.n1 === item.n1) {
						if (anterior.n2 === 0 && item.n2 > 0) {
							return true;
						}
						if (anterior.n2 < item.n2) {
							break;
						}
					}

					if (anterior.n1 !== item.n1) {
						break;
					}
				}
			}

			if (item.tipo === "E" && array && Array.isArray(array) && index !== undefined) {
				for (let i = index + 1; i < array.length; i++) {
					const siguiente = array[i];
					if (!siguiente) continue;

					if (siguiente.tipo === "I" &&
						siguiente.n1 === item.n1 &&
						siguiente.n2 === item.n2) {

						const descEncabezado = (item.descripcion || '').trim().toLowerCase();
						const descInfo = (siguiente.descripcion || '').trim().toLowerCase();

						if (!descEncabezado.includes(descInfo) && !descInfo.includes(descEncabezado)) {
							return false;
						} else {
							break;
						}
					}

					if (siguiente.tipo === "E" && siguiente.n2 !== item.n2) {
						break;
					}
				}
			}

			if (item.n2 === 99 && item.n3 === 99 && item.n4 === 99) {
				return false;
			}

			if (item.n2 >= 1 && item.n2 <= 98 && item.n3 === 0 && item.n4 === 0) {
				return true;
			}

			if (item.n2 >= 1 && item.n2 <= 98 && item.n3 === 99 && item.n4 === 99) {
				return true;
			}

			return false;
		},
		f_titulo_informacion() {
			if(this.infAjusteComb) {
				return "Ajustes al combinado"
			} else if(this.infAjusteConsol) {
				return "Ajustes al Consolidado"
			} else {
				return "Información Manual"
			}
		},
		f_titulo() {
                        this.indirecto = true;
  
			let titulo = ""
			let tituloEN = ""
			let tituloConsolidado = ""
			titulo = "FLUJO DE EFECTIVO"
			tituloEN = "CASH FLOW "
			if (this.$store.state._language == "es-ES") {
				tituloConsolidado = titulo
			} else {
				tituloConsolidado = tituloEN
			}
			if (this.comparativo) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = titulo.concat(" COMPARATIVO")
				} else {
					tituloConsolidado = "COMPARATIVE"
					tituloConsolidado = tituloConsolidado.concat(" ", tituloEN)
				}
			}
			if (this.directo) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = titulo.concat("-DIRECTO")
				} else {
					tituloConsolidado = tituloEN.concat("-DIRECT")
				}
			}
			if (this.indirecto) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = titulo.concat("-INDIRECTO")
				} else {
					tituloConsolidado = tituloEN.concat("-INDIRECT")
				}
			}
			if (this.informacion) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = tituloConsolidado.concat(" INFORMACION")
				} else {
					tituloConsolidado = tituloConsolidado.concat(" INFORMATION")
				}
			}
			if (this.infAjusteConsol) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = tituloConsolidado.concat(" AJUSTE CONSOLIDACION")
				} else {
					tituloConsolidado = tituloConsolidado.concat(" CONSOLIDATED ADJUSTMENT")
				}
			}
			if (this.infAjusteComb) {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = tituloConsolidado.concat(" AJUSTE COMBINACION")
				} else {
					tituloConsolidado = tituloConsolidado.concat(" COMBINATION ADJUSTMENT")
				}
			}
			if (this.consolidado && this.vistaConsolidado === 'Normal') {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = tituloConsolidado.concat(" (CONSOLIDADO)")
				} else {
					tituloConsolidado = tituloConsolidado.concat(" (CONSOLIDATED)")
				}
			}
			if (this.consolidado && this.vistaConsolidado === 'Combinado') {
				if (this.$store.state._language == "es-ES") {
					tituloConsolidado = tituloConsolidado.concat(" (COMBINADO)")
				} else {
					tituloConsolidado = tituloConsolidado.concat(" (COMBINADO)")
				}
			}
			tituloConsolidado = tituloConsolidado.concat(" ", this.vigencia.toUpperCase());
			if (this.moneda) {
				tituloConsolidado = tituloConsolidado.concat(" ", this.labels.moneda, " ", this.moneda);
			}
			return tituloConsolidado
		},
		f_columnas() {
			if (this.balance && this.balance.length > 0 && this.balance[0]) {
				// Limpiar el array
				this.titulo_columna = [];

				// Recorrer todas las propiedades del objeto
				const primerItem = this.balance[0];

				// Las propiedades están ordenadas, pero necesitamos extraer solo las que son títulos
				// Suponiendo que las propiedades e1, e2, e3... vienen en orden
				let i = 1;
				while (primerItem['e' + i] !== undefined) {
					this.titulo_columna.push(primerItem['e' + i]);
					i++;
				}

				// Actualizar columnas si es necesario
				if (this.titulo_columna.length > 0) {
					this.columnas = this.titulo_columna.length;
				}
			}
		},

		generar() {
			if (!this.empresas || this.EmpresasConsolida.length === 0) {
				if (!this.dialogCompanias) {
					this.$toast.warning("Por favor seleccione una compañía");
					return;
				}
			}

			if (!this.dialogFechas) {
				this.$toast.warning("Por favor seleccione una vigencia");
				return;
			}
			if (!this.dialogReportes) {
				this.$toast.warning("Por favor seleccione un reporte");
				return;
			}

			this.isLoading = true;
			this.idCompania = this.dialogCompanias;
			this.vigencia = this.dialogFechas;
			this.codReporte = this.dialogReportes;
			this.isEmpty = true;
			this.generado = false;

			const empresasSeleccionadas = [...this.EmpresasConsolida];
			const hayEmpresasSeleccionadas = this.empresas && empresasSeleccionadas.length > 0;

			this.empresas = false;
			this.selectAllCompanies = false;

			const checkboxEmpresas = document.getElementById("Empresas");
			if (checkboxEmpresas) {
				checkboxEmpresas.checked = false;
			}

			if (this.comparativo) {
				Balance.getReporteEfe(this.idCompania, this.vigencia, this.codReporte)
					.then((result) => {
						this.balance = result.data.reporteEfe;
						this.searched = this.balance;
						if (this.balance && this.balance.length != 0) {
							this.isEmpty = false;
							this.generado = true;
						}
						this.isLoading = false;
					})
					.catch(() => {
						this.error = true;
						this.isLoading = false;
					});
				return;
			}

			if (this.infAjusteConsol && (this.directo || this.indirecto) && this.codReporte) {
				Balance.getReporteInformacionConsolidado(this.idCompania, this.vigencia, this.codReporte, this.directo, this.$store.state.userId)
					.then((result) => {
						this.balance = result.data.informacionManual;
						this.searched = this.balance;
						if (this.balance && this.balance.length != 0) {
							this.isEmpty = false;
							this.generado = true;
						}
						this.isLoading = false;
					})
					.catch(() => {
						this.error = true;
						this.isLoading = false;
					});
				return;
			}
			if (this.infAjusteComb && (this.directo || this.indirecto) && this.codReporte) {
				Balance.getReporteInformacionCombinado(this.idCompania, this.vigencia, this.codReporte, this.directo, this.$store.state.userId)
					.then((result) => {
						this.balance = result.data.informacionManual;
						this.searched = this.balance;
						if (this.balance && this.balance.length != 0) {
							this.isEmpty = false;
							this.generado = true;
						}
						this.isLoading = false;
					})
					.catch(() => {
						this.error = true;
						this.isLoading = false;
					});
				return;
			}

			if (this.informacion && (this.directo || this.indirecto) && this.codReporte) {
				Balance.getReporteInformacion(this.idCompania, this.vigencia, this.codReporte, this.directo, this.$store.state.userId)
					.then((result) => {
						this.balance = result.data.informacionManual;
						this.searched = this.balance;
						if (this.balance && this.balance.length != 0) {
							this.isEmpty = false;
							this.generado = true;
						}
						this.isLoading = false;
					})
					.catch(() => {
						this.error = true;
						this.isLoading = false;
					});
				return;
			}

			if (this.directo && !this.informacion && !this.infAjusteConsol && !this.infAjusteComb && this.codReporte) {
				let empresasParam = [];
				if (!hayEmpresasSeleccionadas) {
					empresasParam = [this.idCompania];
				} else {
					empresasParam = empresasSeleccionadas;
				}

				Balance.getReporteEfeDirecto(empresasParam, this.vigencia, this.codReporte, this.nivel, this.consolidado)
					.then((result) => {
						this.balance = result.data.reporteEfe;
						this.searched = this.balance;
						if (this.balance && this.balance.length != 0) {
							this.isEmpty = false;
							this.generado = true;
							this.columnas = this.balance[0]?.columnas || 0;
							this.f_columnas();
						}
						this.EmpresasConsolida = [];
						this.isLoading = false;
					})
					.catch(() => {
						this.error = true;
						this.isLoading = false;
					});
				return;
			}

			if (this.indirecto && !this.informacion && !this.infAjusteConsol && !this.infAjusteComb && this.codReporte) {
				let empresasParam = [];
				if (!hayEmpresasSeleccionadas) {
					empresasParam = [this.idCompania];
				} else {
					empresasParam = empresasSeleccionadas;
				}

				Balance.getReporteEfeIndirecto(empresasParam, this.vigencia, this.codReporte, this.nivel, this.consolidado)
					.then((result) => {
						this.balance = result.data.reporteEfe;
						this.searched = this.balance;
						if (this.balance && this.balance.length != 0) {
							this.isEmpty = false;
							this.generado = true;
							this.columnas = this.balance[0]?.columnas || 0;
							this.f_columnas();
						}
						this.EmpresasConsolida = [];
						this.isLoading = false;
					})
					.catch(() => {
						this.error = true;
						this.isLoading = false;
					});
				return;
			}
		},

		f_escribe_renglon(v_informacion) {
			if (v_informacion === "E") return false;
			return true;
		},

		uncheck(opcion) {
			var checkbox0 = document.getElementById("informacion");
			var checkboxInfAjusteConsol = document.getElementById("infAjusteConsol");
			var checkboxInfAjusteComb = document.getElementById("infAjusteComb");
			/*
			var checkbox1 = document.getElementById("comparativo");
			var checkbox2 = document.getElementById("directo");
			*/
			var checkbox3 = document.getElementById("indirecto");
			var checkboxn1 = document.getElementById("nivel_1");
			var checkboxn2 = document.getElementById("nivel_2");
			var checkboxn3 = document.getElementById("nivel_3");
			var checkboxn4 = document.getElementById("nivel_4");
			var checkbox4 = document.getElementById("consolidado");

			if (opcion == 41) {
				if (this.empresas) {
					this.empresas = false;
					this.EmpresasConsolida = [];
				} else {
					this.empresas = true;
				}
				return;
			}

			const estabaIndirecto = this.indirecto;

			if (opcion == 4) {
				if (!this.directo && !this.indirecto) {
					checkbox4.checked = false;
					this.isEmpty = true;
					this.generado = false;
					return;
				} else {
					// Desmarcar Informacion e Inf. Consolidado
					checkbox0.checked = false;
					if (checkboxInfAjusteConsol) checkboxInfAjusteConsol.checked = false;
					if (checkboxInfAjusteComb) checkboxInfAjusteComb.checked = false;
					this.informacion = false;
					this.infAjusteConsol = false;
					this.infAjusteComb = false;

					if (this.consolidado) {
						checkbox4.checked = false;
						this.consolidado = false;
					} else {
						checkbox4.checked = true;
						this.consolidado = true;
					}
					if (this.nivel == 0) {
						this.nivel = 1;
						checkboxn1.checked = true;
					}
					this.isEmpty = true;
					this.generado = false;
					return;
				}
			} else {
				this.empresas = false;
				checkbox0.checked = false;
				if (checkboxInfAjusteConsol) checkboxInfAjusteConsol.checked = false;
				if (checkboxInfAjusteComb) checkboxInfAjusteComb.checked = false;
				/*
				checkbox1.checked = false;
				checkbox2.checked = false;
				*/
				checkbox3.checked = true;
				checkboxn1.checked = false;
				checkboxn2.checked = false;
				checkboxn3.checked = false;
				checkboxn4.checked = false;
				checkbox4.checked = false;
			}

			this.consolidado = false;
			this.informacion = false;
			this.infAjusteConsol = false;
			this.infAjusteComb = false;
			this.comparativo = false;
			this.directo = false;
			this.indirecto = true;

			/*if (opcion == 1) {
				checkbox1.checked = true;
				this.comparativo = true;
			}
			if (opcion == 2) {
				checkbox2.checked = true;
				this.directo = true;
			}*/
			if (opcion == 3) {
				// Permitir alternar: si estaba activo, desmarcarlo.
				if (!estabaIndirecto) {
					checkbox3.checked = true;
					this.indirecto = true;
				}
			}
			if (opcion == 4) {
				checkbox4.checked = true;
				this.consolidado = true;
			}
			if (opcion == 5) {
				checkboxInfAjusteConsol.checked = true;
				this.consolidado = true;
			}
			if (opcion == 6) {
				checkboxInfAjusteComb.checked = true;
				this.consolidado = true;
			}
			this.isEmpty = true;
			this.generado = false;
		},

		seleccionaCompania() {
			this.isEmpty = true;
			let buscaMoneda = this.companias.filter((item) => item.id == this.dialogCompanias);
			if (buscaMoneda.length > 0) {
				this.moneda = buscaMoneda[0].acronimo;
			}
		},

		uncheck_nivel(opcion) {
			var checkbox0 = document.getElementById("informacion");
			var checkboxInfAjusteConsol = document.getElementById("infAjusteConsol");
			var checkboxInfAjusteComb = document.getElementById("infAjusteComb");
			var checkbox1 = document.getElementById("nivel_1");
			var checkbox2 = document.getElementById("nivel_2");
			var checkbox3 = document.getElementById("nivel_3");
			var checkbox4 = document.getElementById("nivel_4");
			var checkbox5 = document.getElementById("consolidado");
			/*var checkboxComparativo = document.getElementById("comparativo");*/

			// Si se hace clic en Informacion (opcion == 0)
			if (opcion == 0) {
				// Desmarcar todos los niveles
				checkbox1.checked = false;
				checkbox2.checked = false;
				checkbox3.checked = false;
				checkbox4.checked = false;
				this.nivel = 0;

				// Si Informacion estaba marcado, lo desmarcamos
				if (this.informacion) {
					checkbox0.checked = false;
					this.informacion = false;
				} else {
					// Si no estaba marcado, lo marcamos y desmarcamos Inf. Consolidado y otros
					checkbox0.checked = true;
					this.informacion = true;

				}
				// Desmarcar Inf. Consolidado
				if (checkboxInfAjusteConsol) {
					checkboxInfAjusteConsol.checked = false;
					this.infAjusteConsol = false;
				}
				if (checkboxInfAjusteComb) {
					checkboxInfAjusteComb.checked = false;
					this.infAjusteComb = false;
				}

				// Desmarcar Comparativo si estaba
				/*if (this.comparativo) {
					checkboxComparativo.checked = false;
					this.comparativo = false;
				}*/

				// Desmarcar Consolidado
				this.consolidado = false;
				checkbox5.checked = false;
				this.comparativo = false;
				this.consolidado = false;
				checkbox5.checked = false;
				this.isEmpty = true;
				this.generado = false;
				return;
			}

			// Si se hace clic en Inf. Consolidado (nueva opcion 5)
			if (opcion == 5) {
				// Desmarcar todos los niveles
				checkbox1.checked = false;
				checkbox2.checked = false;
				checkbox3.checked = false;
				checkbox4.checked = false;
				this.nivel = 0;

				// Si Inf. Consolidado estaba marcado, lo desmarcamos
				if (this.infAjusteConsol) {
					checkboxInfAjusteConsol.checked = false;
					this.infAjusteConsol = false;
				} else {
						// Si no estaba marcado, lo marcamos y desmarcamos Informacion y otros
					checkboxInfAjusteConsol.checked = true;
					this.infAjusteConsol = true;
				}
	
						// Desmarcar Informacion
				if (this.informacion) {
					checkbox0.checked = false;
					this.informacion = false;
				}

				checkboxInfAjusteComb.checked = false;
				this.infAjusteComb = false;
				this.consolidado = false;
				checkbox5.checked = false;
				this.comparativo = false;
				this.consolidado = false;
				checkbox5.checked = false;
				this.isEmpty = true;
				this.generado = false;
				return;
			}
			if (opcion == 6) {
				// Desmarcar todos los niveles
				checkbox1.checked = false;
				checkbox2.checked = false;
				checkbox3.checked = false;
				checkbox4.checked = false;
				this.nivel = 0;

				// Si Inf. Consolidado estaba marcado, lo desmarcamos
				if (this.infAjusteComb) {
					checkboxInfAjusteComb.checked = false;
					this.infAjusteComb = false;
				} else {
						// Si no estaba marcado, lo marcamos y desmarcamos Informacion y otros
					checkboxInfAjusteComb.checked = true;
					this.infAjusteComb = true;
				}

					// Desmarcar Informacion
				if (this.informacion) {
					checkbox0.checked = false;
					this.informacion = false;
				}

				// Desmarcar Comparativo si estaba
				/*if (this.comparativo) {
					checkboxComparativo.checked = false;
					this.comparativo = false;
				}*/

				// Desmarcar Consolidado
				checkboxInfAjusteConsol.checked = false;
				this.infAjusteConsol = false;
				this.consolidado = false;
				checkbox5.checked = false;
				this.comparativo = false;
				this.consolidado = false;
				checkbox5.checked = false;
				this.isEmpty = true;
				this.generado = false;
				return;
			}

			// Para niveles (1,2,3,4) - desmarcar Informacion e Inf. Consolidado
			if (checkbox0) checkbox0.checked = false;
			if (checkboxInfAjusteConsol) checkboxInfAjusteConsol.checked = false;
			if (checkboxInfAjusteComb) checkboxInfAjusteComb.checked = false;
			this.informacion = false;
			this.infAjusteConsol = false;
			this.infAjusteComb = false;

			// Si hay Comparativo activo, no permitir seleccionar niveles
			if (this.comparativo) {
				return;
			}

			// Gestionar selección de niveles (solo uno a la vez)
			// Desmarcar todos primero
			checkbox1.checked = false;
			checkbox2.checked = false;
			checkbox3.checked = false;
			checkbox4.checked = false;

			// Marcar solo el seleccionado
			switch (opcion) {
				case 1:
					checkbox1.checked = true;
					this.nivel = 1;
					break;
				case 2:
					checkbox2.checked = true;
					this.nivel = 2;
					break;
				case 3:
					checkbox3.checked = true;
					this.nivel = 3;
					break;
				case 4:
					checkbox4.checked = true;
					this.nivel = 4;
					break;
				case 5:
					checkboxInfAjusteConsol.checked = true;
					break;
				case 6:
					checkboxInfAjusteComb.checked = true;
					break;
			}

			this.isEmpty = true;
			this.generado = false;
		},

		formato(numero) {
			if (numero === null || numero === undefined) return '';
			if (typeof numero === 'string') {
				numero = parseFloat(numero) || 0;
			}
			return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(numero);
		},

		excel(opcion) {
			let datos = {};
			if (opcion === 1) {
				datos.opcion = 1;
				datos.idCompania = this.idCompania;
				const v_compania = this.companias.find((compania) => compania.id === this.idCompania);
				datos.compania = v_compania ? v_compania.nombre : '';
				datos.vigencia = this.vigencia;
				datos.titulo = this.f_titulo();
				datos.columnas = [
					this.labels.saldo_anterior,
					this.labels.saldo_actual,
					this.labels.diferencia,
				];
				datos.informacion = this.balanceFiltrado;
				datos.userId = this.$store.state.userId;
				datos.userName = this.$store.state.userName;
				this.hojaExcelReporteEfe(datos);
			}
			if (opcion === 2) {
				if (this.directo) {
					datos.opcion = 1;
				} else {
					datos.opcion = 2;
				}
				datos.idCompania = this.idCompania;
				const v_compania = this.companias.find((compania) => compania.id === this.idCompania);
				datos.compania = v_compania ? v_compania.nombre : '';
				datos.vigencia = this.vigencia;
				datos.titulo = this.f_titulo();
				datos.columnas = [
					this.labels.descripcion,
					this.labels.monto
				];
				datos.informacion = this.balanceFiltrado;
				datos.userId = this.$store.state.userId;
				datos.userName = this.$store.state.userName;
				this.hojaExcelReporteEfeDirecto(datos);
			}
			if (opcion === 3) {
				if (this.directo) {
					datos.opcion = 1;
				} else {
					datos.opcion = 2;
				}
				datos.idCompania = this.idCompania;
				const v_compania = this.companias.find((compania) => compania.id === this.idCompania);
				datos.compania = v_compania ? v_compania.nombre : '';
				datos.vigencia = this.vigencia;
				datos.titulo = this.f_titulo();
				datos.columnas = [
					this.labels.nivel1,
					this.labels.nivel2,
					this.labels.nivel3,
					this.labels.nivel4,
					this.labels.monto,
					this.labels.funcional1
				];
				datos.informacion = this.balanceFiltrado;
				datos.userId = this.$store.state.userId;
				datos.userName = this.$store.state.userName;
				this.hojaExcelReporteEfeInformacion(datos);
			}
			if (opcion === 4) {
				if (this.directo) {
					datos.opcion = 1;
				} else {
					datos.opcion = 2;
				}
				datos.idCompania = this.idCompania;
				const v_compania = this.companias.find((compania) => compania.id === this.idCompania);
				datos.compania = v_compania ? v_compania.nombre : '';
				datos.idGrupo = this.grupoId;
				const v_grupo = this.listGrupos.find((grupo) => grupo.id === this.grupoId);
				datos.grupo = v_grupo ? v_grupo.nombre : '';
				datos.vigencia = this.vigencia;
				datos.titulo = this.f_titulo();

				// Construir los títulos de las columnas dinámicamente
				const columnasTitulos = [];
				for (let i = 0; i < this.columnas; i++) {
					columnasTitulos.push(this.titulo_columna[i] || `Empresa ${i + 1}`);
				}

				datos.columnas = [
					this.labels.descripcion,
					...columnasTitulos,
					this.labels.ajustes,
					this.labels.consolidado
				];

				datos.informacion = this.balanceFiltrado;
				datos.columnasCount = this.columnas;
				datos.userId = this.$store.state.userId;
				datos.userName = this.$store.state.userName;
				this.hojaExcelReporteEfeConsolidado(datos);
			}

			if (opcion === 5) {
				if (this.directo) {
					datos.opcion = 1;
				} else {
					datos.opcion = 2;
				}
				datos.idCompania = this.idCompania;
				const v_compania = this.companias.find((compania) => compania.id === this.idCompania);
				datos.compania = v_compania ? v_compania.nombre : '';
				datos.vigencia = this.vigencia;
				datos.titulo = this.f_titulo();
				datos.columnas = [
					this.labels.nivel1,
					this.labels.nivel2,
					this.labels.nivel3,
					this.labels.nivel4,
					this.labels.monto,
					this.labels.funcional1
				];
				datos.informacion = this.balanceFiltrado;
				datos.userId = this.$store.state.userId;
				datos.userName = this.$store.state.userName;
				this.hojaExcelReporteEfeInformacionConsolidado(datos);
			}
		},

		async hojaExcelReporteEfeInformacionConsolidado(datos) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
			let dia = String(createdAt1.getDate()).padStart(2, '0')
			let createdAt = anio + "-" + mes + "-" + dia

			let opcion = datos.opcion
			let compania = datos.compania
			let vigencia = datos.vigencia
			let titulo = datos.titulo
			let userName = datos.userName
			const filas = datos.informacion

			if (!filas || filas.length === 0) {
				this.$toast.warning("No hay datos para exportar")
				return
			}

			const { Workbook } = XLSX
			const workbook = new Workbook()
			const worksheet = workbook.addWorksheet(opcion === 1 ? "Directo Inf Consolidado" : "Indirecto Inf Consolidado")

			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				encabezado: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				datoNormal: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						left: { style: "thin" },
						right: { style: "thin" }
					}
				}
			}

			worksheet.mergeCells('A1:F1')
			worksheet.getCell('A1').value = titulo
			Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

			worksheet.mergeCells('A2:F2')
			worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
			Object.assign(worksheet.getCell('A2'), styles.subtitulo)

			worksheet.mergeCells('A3:F3')
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName}`
			Object.assign(worksheet.getCell('A3'), styles.subtitulo)

			worksheet.addRow([])

			const HEADER_ROW = [
				'NIVEL 1',
				'NIVEL 2',
				'NIVEL 3',
				'NIVEL 4',
				'VALOR',
				"FUNCIONAL"
			]

			const headerRow = worksheet.addRow(HEADER_ROW)
			headerRow.eachCell((cell) => {
				Object.assign(cell, styles.encabezado)
			})

			filas.forEach((fila) => {
				const v_fila = [
					fila.nivel_1_desc || '',
					fila.nivel_2_desc || '',
					fila.nivel_3_desc || '',
					fila.nivel_4_desc || '',
					fila.valor !== null ? parseFloat(fila.valor) || 0 : 0,
					fila.funcional1 !== null ? parseFloat(fila.funcional1) || 0 : 0
				]

				const currentRow = worksheet.addRow(v_fila)
				currentRow.eachCell((cell, colNumber) => {
					if (colNumber < 5) {
						cell.font = { name: "Calibri", size: 10 }
						cell.alignment = { horizontal: "left", vertical: "middle" }
					} else {
						Object.assign(cell, styles.datoNormal)
					}
					cell.border = {
						left: { style: "thin" },
						right: { style: "thin" },
						top: { style: "thin" },
						bottom: { style: "thin" }
					}
				})
			})

			worksheet.columns = [
				{ width: 30 },
				{ width: 30 },
				{ width: 30 },
				{ width: 30 },
				{ width: 20 },
				{ width: 20 }
			]

			worksheet.views = [
				{ state: 'frozen', ySplit: 6 }
			]

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")
			downloadLink.download = (opcion === 1 ? "Directo_Inf_Consolidado_" : "Indirecto_Inf_Consolidado_") + vigencia + "_" + createdAt + ".xlsx"
			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none"
			document.body.appendChild(downloadLink)
			downloadLink.click()
			document.body.removeChild(downloadLink)
			window.URL.revokeObjectURL(downloadLink.href)
		},

		async hojaExcelReporteEfeConsolidado(datos) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
			let dia = String(createdAt1.getDate()).padStart(2, '0')
			let createdAt = anio + "-" + mes + "-" + dia

			let opcion = datos.opcion
			let compania = datos.compania
			let grupo = datos.grupo
			let vigencia = datos.vigencia
			let titulo = datos.titulo
			let columnasCount = datos.columnasCount
			let userName = datos.userName

			const filasFiltradas = datos.informacion.filter(item => !this.ocultarRegistro(item));

			if (!filasFiltradas || filasFiltradas.length === 0) {
				this.$toast.warning("No hay datos para exportar")
				return
			}

			const { Workbook } = XLSX
			const workbook = new Workbook()
			const worksheet = workbook.addWorksheet(opcion === 1 ? "Consolidado Directo" : "Consolidado Indirecto")

			var endCol = ''
			var totalColumns = 0
			if	(this.vistaConsolidado === 'Combinado') {
				totalColumns = 5 + columnasCount // Descripción + columnasCount + Ajustes + Consolidado + Combinado + TotalCombinado
				endCol = String.fromCharCode(65 + totalColumns - 1)
			} else	{
				totalColumns = 3 + columnasCount // Descripción + columnasCount + Ajustes + Consolidado
				endCol = String.fromCharCode(65 + totalColumns - 1)
			}

			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				encabezado: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				nivel1: {
					font: { name: "Calibri", size: 12, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
					border: {
						bottom: { style: "thin" }
					}
				},
				nivel2: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F8F8F8" } },
					indent: 1
				},
				datoNormal: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						left: { style: "thin" },
						right: { style: "thin" }
					},
					indent: 2
				},
				total: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				},
				descripcionTotal: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				}
			}

			// ENCABEZADO PRINCIPAL

			worksheet.mergeCells(`A1:${endCol}1`)
			worksheet.getCell('A1').value = titulo
			Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

			worksheet.mergeCells(`A2:${endCol}2`)
			if	(this.vistaConsolidado === 'Combinado') {
				worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Grupo: ${grupo}`
			} else	{
				worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
			}
			Object.assign(worksheet.getCell('A2'), styles.subtitulo)

			worksheet.mergeCells(`A3:${endCol}3`)
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName}`
			Object.assign(worksheet.getCell('A3'), styles.subtitulo)

			worksheet.addRow([])

			// Construir encabezado de columnas
			const headerRowArray = ['DESCRIPCIÓN']
			for (let i = 0; i < columnasCount; i++) {
				headerRowArray.push(this.titulo_columna[i] || `Empresa ${i + 1}`)
			}
			headerRowArray.push('AJUSTES')
			headerRowArray.push('CONSOLIDADO')
			if	(this.vistaConsolidado === 'Combinado') {
				headerRowArray.push('COMBINADO')
				headerRowArray.push('TOTAL')
			}

			if (this.vistaConsolidado === 'Combinado') {
				headerRowArray.push('AJUSTES COMBINADO')
				headerRowArray.push('COMBINADO')
			}

			const headerRow = worksheet.addRow(headerRowArray)
			headerRow.eachCell((cell) => {
				Object.assign(cell, styles.encabezado)
			})

			// PROCESAR FILAS
			let n_fila = 6

			filasFiltradas.forEach((fila) => {
				if (fila.informacion === "E") {
					// ENCABEZADO DE SECCIÓN
					const rowData = [fila.descripcion || '']
					for (let i = 0; i < columnasCount + 2; i++) {
						rowData.push('')
					}
					worksheet.addRow(rowData)
					worksheet.mergeCells(`A${n_fila}:${endCol}${n_fila}`)
					Object.assign(worksheet.getCell(`A${n_fila}`), styles.nivel1)
					n_fila++

				} else if (this.f_escribe_renglon(fila.informacion)) {
					const rowData = [fila.descripcion || '']

					// Agregar valores de las compañías
					for (let i = 1; i <= columnasCount; i++) {
						const valor = fila[`c${i}`] !== null ? parseFloat(fila[`c${i}`]) || 0 : 0
						rowData.push(valor)
					}

					// Agregar ajustes y total
					const ajustes = fila.ajustes !== null ? parseFloat(fila.ajustes) || 0 : 0
					const total = fila.total !== null ? parseFloat(fila.total) || 0 : 0
					rowData.push(ajustes)
					rowData.push(total)
					if	(this.vistaConsolidado === 'Combinado') {
						const combinado = fila.combinado !== null ? parseFloat(fila.combinado) || 0 : 0
						const total_combinado = fila.total_combinado !== null ? parseFloat(fila.total_combinado) || 0 : 0
						rowData.push(combinado)
						rowData.push(total_combinado)
					}

					const currentRow = worksheet.addRow(rowData)

					// APLICAR ESTILOS SEGÚN EL TIPO DE FILA
					if (fila.informacion === "T" || (fila.informacion === "S" && fila.segundo_nivel === 999)) {
						// TOTALES
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber === 1) {
								Object.assign(cell, styles.descripcionTotal)
							} else {
								Object.assign(cell, styles.total)
							}
						})
					} else {
						// FILAS NORMALES
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber === 1) {
								// Columna descripción - diferenciar niveles
								if (fila.segundo_nivel > 0 && fila.segundo_nivel < 999) {
									Object.assign(cell, styles.nivel2)
								} else {
									cell.font = { name: "Calibri", size: 10 }
									cell.alignment = { horizontal: "left", vertical: "middle" }
									cell.indent = 2
								}
							} else {
								// Columnas numéricas
								Object.assign(cell, styles.datoNormal)
							}
						})
					}
					n_fila++
				}
			})

			// AJUSTAR ANCHO DE COLUMNAS
			const columnWidths = [
				{ width: 50 } // Descripción
			]
			for (let i = 0; i < columnasCount; i++) {
				columnWidths.push({ width: 18 })
			}
			columnWidths.push({ width: 18 }) // Ajustes
			columnWidths.push({ width: 18 }) // Consolidado
			if	(this.vistaConsolidado === 'Combinado') {
				columnWidths.push({ width: 18 }) // Ajustes
				columnWidths.push({ width: 18 }) // Consolidado
			}

			worksheet.columns = columnWidths

			// AGREGAR BORDES VERTICALES
			const lastRow = n_fila - 1;
			for (let row = 6; row <= lastRow; row++) {
				for (let col = 1; col <= totalColumns; col++) {
					const cell = worksheet.getCell(row, col);
					if (!cell.border) {
						cell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							top: { style: "thin" },
							bottom: { style: "thin" }
						};
					}
				}
			}

			// CONGELAR PANELES
			worksheet.views = [
				{ state: 'frozen', ySplit: 5 }
			]

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")
			const nombreArchivo = (opcion === 1 ? "Consolidado_Directo_Nivel" : "Consolidado_Indirecto_Nivel") +
				this.nivel + "_" + vigencia + "_" + createdAt + ".xlsx"
			downloadLink.download = nombreArchivo
			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none"
			document.body.appendChild(downloadLink)
			downloadLink.click()
			document.body.removeChild(downloadLink)
			window.URL.revokeObjectURL(downloadLink.href)
		},

		f_muestraConsolidado(r_informacion) {
			this.showDialogInformacion = true;
			this.formInformacion = { ...r_informacion };
			this.formInformacion.esConsolidado = 1;
		},
		f_muestraCombinado(r_informacion) {
			this.showDialogInformacion = true;
			this.formInformacion = { ...r_informacion };
			this.formInformacion.esConsolidado = 2;
		},

		async hojaExcelReporteEfe(datos) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
			let dia = String(createdAt1.getDate()).padStart(2, '0')
			let createdAt = anio + "-" + mes + "-" + dia

			let compania = datos.compania
			let vigencia = datos.vigencia
			let titulo = datos.titulo
			let userName = datos.userName
			const filas = datos.informacion

			if (!filas || filas.length === 0) {
				this.$toast.warning("No hay datos para exportar")
				return
			}

			const { Workbook } = XLSX
			const workbook = new Workbook()
			const worksheet = workbook.addWorksheet("ComparativoEFE")

			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				encabezado: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				nivel1: {
					font: { name: "Calibri", size: 12, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
					border: {
						bottom: { style: "thin" }
					}
				},
				nivel2: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F8F8F8" } },
					indent: 1
				},
				datoNormal: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						left: { style: "thin" },
						right: { style: "thin" },
						top: { style: "thin" },
						bottom: { style: "thin" }
					},
					indent: 2
				},
				total: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				},
				descripcionTotal: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				}
			}

			// ENCABEZADO PRINCIPAL
			worksheet.mergeCells('A1:D1')
			worksheet.getCell('A1').value = titulo
			Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

			worksheet.mergeCells('A2:D2')
			worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
			Object.assign(worksheet.getCell('A2'), styles.subtitulo)

			worksheet.mergeCells('A3:D3')
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName}`
			Object.assign(worksheet.getCell('A3'), styles.subtitulo)

			worksheet.addRow([])

			// ENCABEZADO DE COLUMNAS
			const HEADER_ROW = [
				'DESCRIPCIÓN',
				'SALDO ANTERIOR',
				'SALDO ACTUAL',
				'DIFERENCIA'
			]

			const headerRow = worksheet.addRow(HEADER_ROW)
			headerRow.eachCell((cell) => {
				Object.assign(cell, styles.encabezado)
			})

			// PROCESAR FILAS
			let n_fila = 6

			filas.forEach((fila) => {
				// Verificar si es un encabezado de sección (informacion === "E")
				if (fila.informacion === "E") {
					// ENCABEZADO DE SECCIÓN - fila gris con negrilla
					const rowData = [fila.descripcion || '', '', '', '']
					worksheet.addRow(rowData)
					worksheet.mergeCells(`A${n_fila}:D${n_fila}`)
					Object.assign(worksheet.getCell(`A${n_fila}`), styles.nivel1)

					// Agregar bordes a toda la fila
					for (let col = 1; col <= 4; col++) {
						const cell = worksheet.getCell(n_fila, col)
						cell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							top: { style: "thin" },
							bottom: { style: "thin" }
						}
					}
					n_fila++

				}
				// Filas con información (informacion !== "E")
				else {
					// Determinar valores numéricos
					const anterior = (fila.anterior !== null && fila.anterior !== undefined)
						? parseFloat(fila.anterior) || 0 : 0
					const actual = (fila.actual !== null && fila.actual !== undefined)
						? parseFloat(fila.actual) || 0 : 0
					const diferencia = (fila.diferencia !== null && fila.diferencia !== undefined)
						? parseFloat(fila.diferencia) || 0 : 0

					const v_fila = [
						fila.descripcion || '',
						anterior,
						actual,
						diferencia
					]

					const currentRow = worksheet.addRow(v_fila)

					// APLICAR ESTILOS SEGÚN EL TIPO DE FILA
					if (fila.informacion === "T") {
						// TOTALES - fila con fondo gris y bordes destacados
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber === 1) {
								// Columna descripción
								cell.font = { name: "Calibri", size: 11, bold: true }
								cell.alignment = { horizontal: "left", vertical: "middle" }
								cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
								cell.border = {
									left: { style: "thin" },
									right: { style: "thin" },
									top: { style: "medium" },
									bottom: { style: "double" }
								}
							} else {
								// Columnas numéricas
								cell.font = { name: "Calibri", size: 11, bold: true }
								cell.alignment = { horizontal: "right", vertical: "middle" }
								cell.numFmt = "#,##0"
								cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
								cell.border = {
									left: { style: "thin" },
									right: { style: "thin" },
									top: { style: "medium" },
									bottom: { style: "double" }
								}
							}
						})
					}
					else if (fila.informacion === "S" && fila.segundo_nivel === 999) {
						// SUBTOTALES especiales - similar a totales
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber === 1) {
								cell.font = { name: "Calibri", size: 11, bold: true }
								cell.alignment = { horizontal: "left", vertical: "middle" }
								cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
							} else {
								cell.font = { name: "Calibri", size: 11, bold: true }
								cell.alignment = { horizontal: "right", vertical: "middle" }
								cell.numFmt = "#,##0"
								cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
							}
						})
					}
					else if (fila.informacion === "I") {
						// FILAS DE INFORMACIÓN NORMAL - con sangría según nivel
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber === 1) {
								// Columna descripción - aplicar sangría según nivel
								cell.font = { name: "Calibri", size: 10 }
								cell.alignment = { horizontal: "left", vertical: "middle" }

								// Aplicar sangría según el segundo_nivel
								if (fila.segundo_nivel > 0 && fila.segundo_nivel < 999) {
									cell.indent = 2 // Sangría para niveles secundarios
									cell.font.bold = true
								} else {
									cell.indent = 1 // Sangría básica
								}
							} else {
								// Columnas numéricas
								cell.font = { name: "Calibri", size: 10 }
								cell.alignment = { horizontal: "right", vertical: "middle" }
								cell.numFmt = "#,##0"
							}

							// Agregar bordes delgados
							cell.border = {
								left: { style: "thin" },
								right: { style: "thin" },
								top: { style: "thin" },
								bottom: { style: "thin" }
							}
						})
					}
					else {
						// OTRAS FILAS (incluyendo las que no tienen informacion específica)
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber === 1) {
								cell.font = { name: "Calibri", size: 10 }
								cell.alignment = { horizontal: "left", vertical: "middle" }
								if (fila.segundo_nivel > 0 && fila.segundo_nivel < 999) {
									cell.font.bold = true
								}
							} else {
								cell.font = { name: "Calibri", size: 10 }
								cell.alignment = { horizontal: "right", vertical: "middle" }
								if (anterior !== 0 || actual !== 0 || diferencia !== 0) {
									cell.numFmt = "#,##0"
								}
							}

							cell.border = {
								left: { style: "thin" },
								right: { style: "thin" },
								top: { style: "thin" },
								bottom: { style: "thin" }
							}
						})
					}

					n_fila++
				}
			})

			// AJUSTAR ANCHO DE COLUMNAS
			worksheet.columns = [
				{ width: 50 }, // Descripción
				{ width: 20 }, // Saldo Anterior
				{ width: 20 }, // Saldo Actual
				{ width: 20 }  // Diferencia
			]

			// CONGELAR PANELES
			worksheet.views = [
				{ state: 'frozen', ySplit: 5 }
			]

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")
			downloadLink.download = `ComparativoEFE_${vigencia}_${createdAt}.xlsx`
			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none"
			document.body.appendChild(downloadLink)
			downloadLink.click()
			document.body.removeChild(downloadLink)
			window.URL.revokeObjectURL(downloadLink.href)
		},

		async hojaExcelReporteEfeDirecto(datos) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
			let dia = String(createdAt1.getDate()).padStart(2, '0')
			let createdAt = anio + "-" + mes + "-" + dia

			let opcion = datos.opcion
			let compania = datos.compania
			let vigencia = datos.vigencia
			let titulo = datos.titulo
			let userName = datos.userName
			const filas = datos.informacion

			if (!filas || filas.length === 0) {
				this.$toast.warning("No hay datos para exportar")
				return
			}

			const { Workbook } = XLSX
			const workbook = new Workbook()
			const worksheet = workbook.addWorksheet(opcion === 1 ? "EFE Directo" : "EFE Indirecto")

			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				encabezado: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				nivel1: {
					font: { name: "Calibri", size: 12, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
					border: {
						bottom: { style: "thin" }
					}
				},
				nivel2: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F8F8F8" } },
					indent: 1
				},
				datoNormal: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						left: { style: "thin" },
						right: { style: "thin" }
					},
					indent: 2
				},
				total: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				},
				descripcionTotal: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				}
			}

			// ENCABEZADO PRINCIPAL
			worksheet.mergeCells('A1:B1')
			worksheet.getCell('A1').value = titulo
			Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

			worksheet.mergeCells('A2:B2')
			worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
			Object.assign(worksheet.getCell('A2'), styles.subtitulo)

			worksheet.mergeCells('A3:B3')
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName}`
			Object.assign(worksheet.getCell('A3'), styles.subtitulo)

			worksheet.addRow([])

			// ENCABEZADO DE COLUMNAS
			const HEADER_ROW = [
				'DESCRIPCIÓN',
				'VALOR'
			]

			const headerRow = worksheet.addRow(HEADER_ROW)
			headerRow.eachCell((cell) => {
				Object.assign(cell, styles.encabezado)
			})

			// PROCESAR FILAS - APLICANDO EL MISMO FILTRO QUE LA VISTA
			let n_fila = 6

			// Primero filtramos las filas usando ocultarRegistro con índice
			const filasVisibles = filas.filter((fila, index) => {
				return !this.ocultarRegistro(fila, index, filas);
			});

			filasVisibles.forEach((fila) => {
				// NUEVO: Filtrar líneas con valor 0 (aunque ya deberían estar filtradas por ocultarRegistro)
				if (fila.tipo === "I" && fila.valor !== null && parseFloat(fila.valor) === 0) {
					return; // Saltar esta fila
				}

				if (fila.tipo === "T" && fila.valor !== null && parseFloat(fila.valor) === 0) {
					return; // Saltar esta fila
				}

				if (fila.tipo === "E") {
					// ENCABEZADO DE SECCIÓN
					const rowData = [this.formatearDescripcion(fila.descripcion || ''), '']
					worksheet.addRow(rowData)
					worksheet.mergeCells(`A${n_fila}:B${n_fila}`)
					Object.assign(worksheet.getCell(`A${n_fila}`), styles.nivel1)

					// Agregar bordes a toda la fila
					for (let col = 1; col <= 2; col++) {
						const cell = worksheet.getCell(n_fila, col)
						cell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							top: { style: "thin" },
							bottom: { style: "thin" }
						}
					}
					n_fila++

				} else if (fila.tipo !== "E") {
					const valor = fila.valor !== null ? parseFloat(fila.valor) || 0 : 0

					const v_fila = [
						this.formatearDescripcion(fila.descripcion || ''),
						valor
					]

					const currentRow = worksheet.addRow(v_fila)

					// APLICAR ESTILOS SEGÚN EL TIPO DE FILA
					if (fila.tipo === "T") {
						// TOTALES
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber === 1) {
								Object.assign(cell, styles.descripcionTotal)
							} else {
								Object.assign(cell, styles.total)
							}
						})
					} else {
						// FILAS NORMALES
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber === 1) {
								// Columna descripción
								cell.font = { name: "Calibri", size: 10 }
								cell.alignment = { horizontal: "left", vertical: "middle" }
								cell.indent = 2

								// Si tiene nivel 2, poner en negrita
								if (fila.n2 > 0 && fila.n2 < 99 && fila.n3 === 0 && fila.n4 === 0) {
									cell.font.bold = true
								}
							} else {
								// Columna valor
								Object.assign(cell, styles.datoNormal)
							}

							cell.border = {
								left: { style: "thin" },
								right: { style: "thin" },
								top: { style: "thin" },
								bottom: { style: "thin" }
							}
						})
					}
					n_fila++
				}
			})

			// AJUSTAR ANCHO DE COLUMNAS
			worksheet.columns = [
				{ width: 60 }, // Descripción
				{ width: 20 }  // Valor
			]

			// CONGELAR PANELES
			worksheet.views = [
				{ state: 'frozen', ySplit: 5 }
			]

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")
			downloadLink.download = (opcion === 1 ? "EFE_Directo_" : "EFE_Indirecto_") + vigencia + "_" + createdAt + ".xlsx"
			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none"
			document.body.appendChild(downloadLink)
			downloadLink.click()
			document.body.removeChild(downloadLink)
			window.URL.revokeObjectURL(downloadLink.href)
		},

		formatearDescripcion(descripcion) {
			if (!descripcion) return '';
			if (descripcion.startsWith('TOTAL ')) {
				return descripcion.substring(6);
			}

			return descripcion;
		},

		async hojaExcelReporteEfeInformacion(datos) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
			let dia = String(createdAt1.getDate()).padStart(2, '0')
			let createdAt = anio + "-" + mes + "-" + dia

			let opcion = datos.opcion
			let compania = datos.compania
			let vigencia = datos.vigencia
			let titulo = datos.titulo
			let userName = datos.userName
			const filas = datos.informacion

			if (!filas || filas.length === 0) {
				this.$toast.warning("No hay datos para exportar")
				return
			}

			const { Workbook } = XLSX
			const workbook = new Workbook()
			const worksheet = workbook.addWorksheet(opcion === 1 ? "Directo Informacion" : "Indirecto Informacion")

			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" }
				},
				encabezado: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				nivel1: {
					font: { name: "Calibri", size: 12, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
					border: {
						bottom: { style: "thin" }
					}
				},
				nivel2: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F8F8F8" } },
					indent: 1
				},
				datoNormal: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						left: { style: "thin" },
						right: { style: "thin" }
					},
					indent: 2
				},
				total: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				},
				descripcionTotal: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "right", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
					border: {
						top: { style: "medium" },
						bottom: { style: "double" }
					}
				}
			}

			// ENCABEZADO PRINCIPAL
			worksheet.mergeCells('A1:F1')
			worksheet.getCell('A1').value = titulo
			Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)

			worksheet.mergeCells('A2:F2')
			worksheet.getCell('A2').value = `Vigencia: ${vigencia} | Compañía: ${compania}`
			Object.assign(worksheet.getCell('A2'), styles.subtitulo)

			worksheet.mergeCells('A3:F3')
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName}`
			Object.assign(worksheet.getCell('A3'), styles.subtitulo)

			worksheet.addRow([])

			// ENCABEZADO DE COLUMNAS
			const HEADER_ROW = [
				'NIVEL 1',
				'NIVEL 2',
				'NIVEL 3',
				'NIVEL 4',
				'VALOR',
				'FUNCIONAL'
			]

			const headerRow = worksheet.addRow(HEADER_ROW)
			headerRow.eachCell((cell) => {
				Object.assign(cell, styles.encabezado)
			})

			// PROCESAR FILAS
			let n_fila = 6

			filas.forEach((fila) => {
				if (fila.tipo === "E") {
					// ENCABEZADO DE SECCIÓN
					const descripcion = fila.nivel_1_desc || fila.nivel_2_desc || fila.nivel_3_desc || fila.nivel_4_desc || ''
					worksheet.addRow([descripcion, '', '', '', ''])
					worksheet.mergeCells(`A${n_fila}:E${n_fila}`)
					Object.assign(worksheet.getCell(`A${n_fila}`), styles.nivel1)
					n_fila++

				} else {
					const v_fila = [
						fila.nivel_1_desc || '',
						fila.nivel_2_desc || '',
						fila.nivel_3_desc || '',
						fila.nivel_4_desc || '',
						fila.valor !== null ? parseFloat(fila.valor) || 0 : 0,
						fila.funcional1 !== null ? parseFloat(fila.funcional1) || 0 : 0
					]

					const currentRow = worksheet.addRow(v_fila)

					// APLICAR ESTILOS SEGÚN EL TIPO DE FILA
					if (fila.tipo === "T") {
						// TOTALES
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber < 5) {
								cell.font = { name: "Calibri", size: 11, bold: true }
								cell.alignment = { horizontal: "left", vertical: "middle" }
								cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } }
							} else {
								Object.assign(cell, styles.total)
							}
						})
					} else {
						// FILAS NORMALES
						currentRow.eachCell((cell, colNumber) => {
							if (colNumber < 5) {
								cell.font = { name: "Calibri", size: 10 }
								cell.alignment = { horizontal: "left", vertical: "middle" }
								cell.indent = 2
							} else {
								Object.assign(cell, styles.datoNormal)
							}
						})
					}
					n_fila++
				}
			})

			// AJUSTAR ANCHO DE COLUMNAS
			worksheet.columns = [
				{ width: 30 }, // Nivel 1
				{ width: 30 }, // Nivel 2
				{ width: 30 }, // Nivel 3
				{ width: 30 }, // Nivel 4
				{ width: 20 }, // Valor
				{ width: 20 }  // Valor
			]

			// AGREGAR BORDES VERTICALES
			const lastRow = n_fila - 1;
			for (let row = 6; row <= lastRow; row++) {
				for (let col = 1; col <= 6; col++) {
					const cell = worksheet.getCell(row, col);
					if (!cell.border) {
						cell.border = {
							left: { style: "thin" },
							right: { style: "thin" },
							top: { style: "thin" },
							bottom: { style: "thin" }
						};
					}
				}
			}

			// CONGELAR PANELES
			worksheet.views = [
				{ state: 'frozen', ySplit: 5 }
			]

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")
			downloadLink.download = (opcion === 1 ? "Directo_Informacion_" : "Indirecto_Informacion_") + vigencia + "_" + createdAt + ".xlsx"
			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none"
			document.body.appendChild(downloadLink)
			downloadLink.click()
			document.body.removeChild(downloadLink)
			window.URL.revokeObjectURL(downloadLink.href)
		},

		f_muestra(r_informacion) {
			this.showDialogInformacion = true;
			this.formInformacion = { ...r_informacion };
			this.formInformacion.esConsolidado = this.infAjusteConsol||this.infAjusteComb;
		},

		f_grabaInformacion() {
			if (this.isVigenciaBloqueada) {
				this.$toast.error('La vigencia seleccionada está deshabilitada para edición.');
				return;
			}
			this.formInformacion.u_modifica = this.$store.state.userId;
			this.formInformacion.directo = this.directo;
			this.showDialogInformacion = false;

			if (this.formInformacion.esConsolidado === 1) {
				Balance.grabaInformacionConsolidado(this.idCompania, this.vigencia, this.codReporte, this.formInformacion)
					.then((result) => {
						if (result.status == 200) {
							this.$toast.success("Informacion Grabada");
							this.generar();
						} else {
							this.$toast.error("Problema al grabar");
						}
					})
					.catch(() => {
						this.error = true;
						this.$toast.error("Error al grabar la información");
					});
			} else if(this.formInformacion.esConsolidado === 2) {
				Balance.grabaInformacionCombinado(this.idCompania, this.vigencia, this.codReporte, this.formInformacion)
					.then((result) => {
						if (result.status == 200) {
							this.$toast.success("Informacion Grabada");
							this.generar();
						} else {
							this.$toast.error("Problema al grabar");
						}
					})
					.catch(() => {
						this.error = true;
						this.$toast.error("Error al grabar la información");
					});
			} else {
				Balance.grabaInformacion(this.idCompania, this.vigencia, this.codReporte, this.formInformacion)
					.then((result) => {
						if (result.status == 200) {
							this.$toast.success("Informacion Grabada");
							this.generar();
						} else {
							this.$toast.error("Problema al grabar");
						}
					})
					.catch(() => {
						this.error = true;
						this.$toast.error("Error al grabar la información");
					});
			}
		}
	},

	async mounted() {
		this.isLoading = true;

		try {
			const resultCompaniaUsuario = await Balance.leaCompaniaUsuario();
			this.companiaUsuario = resultCompaniaUsuario.data.companiaUsuario || [];
		} catch {
			this.error = true;
			this.companiaUsuario = [];
		}

		try {
			const resultCompanias = await Balance.getCompanias(this.comparativo);
			this.companias = resultCompanias.data.companias;
			this.companiasFiltradas = [...this.companias];
			this.dialogCompanias = '';
			this.codigoCompanias = "{";
			let primero = true;
			let v_companias = [];

			resultCompanias.data.companias.forEach((element) => {
				const v_usuario = this.companiaUsuario.find((r_usuario) =>
					r_usuario.id_usuario == this.$store.state.userId &&
					r_usuario.id_compania == element.id);
				if (this.$store.state.userRole == 1 || v_usuario) {
					v_companias.push(element);
				}
			});

			this.companias = v_companias;
			this.companiasFiltradas = [...this.companias];

			resultCompanias.data.companias.forEach(element => {
				if (!primero) {
					this.codigoCompanias = this.codigoCompanias + ",";
				}
				primero = false;
				this.codigoCompanias = this.codigoCompanias + "\"id" + element.id + "\":" +
					"\"" + element.codigo + "\"";
			});

			this.codigoCompanias = this.codigoCompanias + "}";
			this.codigoCompanias = JSON.parse(this.codigoCompanias);
		} catch {
			this.error = true;
		}

		Balance.getFechas()
			.then((result) => {
				this.fechas = result.data.fechas;
				this.dialogFechas = '';
			})
			.catch(() => {
				this.error = true;
			});

		Balance.getReportes()
			.then((result) => {
				this.reportes = result.data.reportes
			})
			.catch(() => {
				this.error = true;
			});

		Grupo.getAllGrupos()
			.then((result) => {
				this.listGrupos = result.data.grupos;
				this.grupoId = 'todos';
			})
			.catch(() => {
				this.error = true;
			});

		this.isLoading = false;
		this.indirecto = false;
	},
};
</script>

<style scoped>
.balance-table {
	font-size: 14px;
}

.balance-table>>>.md-table-head {
	padding: 8px 4px !important;
}

.balance-table>>>.md-table-cell {
	padding: 8px 4px !important;
	min-width: auto !important;
}

.principal-table>>>.md-table-cell:nth-child(1) {
	width: 400px !important;
	max-width: 400px !important;
	white-space: normal !important;
	overflow: visible !important;
	text-overflow: unset !important;
	word-wrap: break-word !important;
	line-height: 1.2 !important;
	height: auto !important;
	min-height: 40px !important;
}

.principal-table>>>.md-table-cell:nth-child(2),
.principal-table>>>.md-table-cell:nth-child(3),
.principal-table>>>.md-table-cell:nth-child(4) {
	width: 200px !important;
	max-width: 200px !important;
}

.detalle-table>>>.md-table-cell:nth-child(1),
.detalle-table>>>.md-table-cell:nth-child(2),
.detalle-table>>>.md-table-cell:nth-child(3),
.detalle-table>>>.md-table-cell:nth-child(4) {
	width: 250px !important;
	max-width: 250px !important;
	white-space: normal !important;
	word-wrap: break-word !important;
	line-height: 1.2 !important;
}

.detalle-table>>>.md-table-cell:nth-child(5) {
	width: 150px !important;
	max-width: 150px !important;
}

.balance-table>>>.md-table {
	width: 100% !important;
	table-layout: fixed !important;
}

.balance-table>>>.md-table-toolbar {
	min-height: 60px !important;
	padding: 8px 16px !important;
}

.px-2 {
	padding-left: 0.5rem !important;
	padding-right: 0.5rem !important;
}

.px-3 {
	padding-left: 1rem !important;
	padding-right: 1rem !important;
}

.excel-btn {
	min-width: 160px !important;
	height: 40px !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	gap: 8px !important;
	margin: 0 4px !important;
	border: none !important;
	font-weight: 600 !important;
}

.excel-btn-text {
	font-size: 14px !important;
	font-weight: 600 !important;
}

.excel-btn.btn-success {
	background-color: #217346 !important;
	border: 1px solid #1a5c38 !important;
}

.excel-btn:not(:disabled):hover {
	transform: translateY(-1px);
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	filter: brightness(1.1);
}

.mr-1 {
	margin-right: 0.25rem !important;
}

.form-control {
	font-size: 0.9rem;
	padding: 0.25rem 0.5rem;
	height: auto;
}

.w-auto {
	width: auto !important;
}

.loading-spinner {
	animation: spin 1s linear infinite;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
}

.fs-5 {
	font-size: 1.25rem !important;
}

.fs-4 {
	font-size: 1.5rem !important;
}

.mb-3 {
	margin-bottom: 1rem !important;
}

.form-control-lg {
	font-size: 1.25rem;
	padding: 0.5rem 1rem;
	height: auto;
	line-height: 1.5;
	border-radius: 0.3rem;
}

.btn-lg {
	padding: 0.5rem 1rem;
	font-size: 1.25rem;
	line-height: 1.5;
	border-radius: 0.3rem;
}

.px-5 {
	padding-left: 3rem !important;
	padding-right: 3rem !important;
}

.mx-2 {
	margin-left: 0.5rem !important;
	margin-right: 0.5rem !important;
}

.consolidation-section {
	background-color: #f8f9fa;
	border: 1px solid #dee2e6;
	max-width: 600px;
	margin: 0 auto;
}

.companies-checkbox-list {
	max-height: 300px;
	overflow-y: auto;
	border: 1px solid #ccc;
	padding: 15px;
	border-radius: 5px;
	background-color: white;
}

.checkbox-group .custom-checkbox {
	margin-bottom: 8px;
}

.company-checkbox {
	font-size: 0.95rem;
	padding: 4px 0;
}
</style>

<style src="../main.css"></style>
